/* import __COLOCATED_TEMPLATE__ from './qualify-lead.hbs'; */
/* RESPONSIBLE TEAM: team-automation-foundations */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type AppService from 'embercom/services/app-service';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency-decorators';
import { type TaskGenerator } from 'ember-concurrency';
import { taskFor } from 'ember-concurrency-ts';
import { get } from 'embercom/lib/ajax';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    accordion: $TSFixMe;
  };
}

// we don't actually care about the other types, we just need to know the length of the routingOutcomes
type SdrConfig = {
  routing_outcomes: any[];
};

export default class QualifyLead extends Component<Signature> {
  @service declare appService: AppService;

  @tracked finSdrConfig: SdrConfig | null = null;

  constructor(owner: any, args: any) {
    super(owner, args);
    taskFor(this.loadFinSdrConfig).perform();
  }

  @task({ restartable: true })
  *loadFinSdrConfig(): TaskGenerator<void> {
    let appId = this.appService.app.id;
    let response = yield get(`/teammate_app/fin_sdr_config?app_id=${appId}`) as SdrConfig;
    this.finSdrConfig = response;
  }

  get qualificationOutcomesCount() {
    return this.finSdrConfig?.routing_outcomes?.length ?? 0;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::Fin::ConversationFlowSections::QualifyLead': typeof QualifyLead;
    'workflows/graph-editor/node-items/steps/fin/conversation-flow-sections/qualify-lead': typeof QualifyLead;
  }
}
